import { useTable } from "./useTable";

export const useAdminTable = () => {
  const table = useTable((admin) => ({
    email: admin.email,
    totalAccounts: admin.totalAccounts,
    ssn: admin.ssn,
    name: `${admin.givenName} ${admin.surname}`,
    phoneNumber: admin.phoneNumber,
    blocked: admin.blocked ? "Spärrad" : "Ja",
  }));

  const getTableHeaders = () => [
    { name: "Mejladress", isSortable: false },
    { name: "Antal konton", isSortable: false },
    { name: "Personnummer", isSortable: false },
    { name: "Namn", isSortable: false },
    { name: "Mobilnummer", isSortable: false },
    { name: "Aktiv", isSortable: false },
  ];

  const updateTableInfo = (tableInfo, admin, updateValues, specialValue) => {
    const indexes = { email: 0, totalAccounts: 1, phoneNumber: 4, blocked: 5 };
    const items = tableInfo.items || tableInfo;

    updateValues.forEach((value) => {
      items[indexes[value]] = { value: specialValue || admin[value] };
    });
  };

  return {
    ...table,
    getTableHeaders,
    updateTableInfo,
  };
};
